import { useLayoutEffect, useState } from 'react';
import {
  competitions,
  regions,
  sports
} from 'utils/constants/sportsbook/data-fields';
import RidGenerator from 'utils/swarm/rid-generator';
import { MenuItem } from 'interfaces/generic';
import { Sport } from 'interfaces/sportsbook-data-levels';
import { executeCommand, unsubscribeCommand } from 'services/get-data-level';
import { GamesFilteredByLeagues } from 'newcomponents/Shared/sportsbook/GameFilteredByLeagues/GamesFilteredByLeagues';
import { useMounted } from 'hooks/useMounted';

type TGamesListFilterByCompetitions = {
  gameIds: number[];
  currentSport?: MenuItem | null | undefined;
};

export type TRequestWhere = {
  game?: {
    id: {
      '@in': number[];
    };
  };
  sport?: {
    alias?: string;
  };
};

export const GamesListFilterByCompetitions = ({
  gameIds,
  currentSport
}: TGamesListFilterByCompetitions) => {
  const [sportsData, setSportsData] = useState<Record<string, Sport> | null>(
    null
  );

  const { mounted } = useMounted();

  const getSportsData = (rId: string, where: Record<string, any>) => {
    const what = {
      sport: sports.sport,
      region: regions.region,
      competition: competitions.competition,
      game: ['id', 'type', 'start_ts']
    };

    const onResponse = (data: { sport: Record<string, Sport> }) => {
      if (data && data.sport && mounted.current) {
        setSportsData(data.sport);
      }
    };

    void executeCommand(rId, what, where, onResponse, true, onResponse);
  };

  useLayoutEffect(() => {
    const rId = RidGenerator.gForSubscribe(
      `ADVANCED_GET_GAMES_BY_COMPETITIONS_FAV_`
    );

    const where: TRequestWhere = {
      game: { id: { '@in': gameIds } }
    };

    if (currentSport?.alias) {
      where.sport = { alias: currentSport?.alias };
    }

    getSportsData(rId, where);

    return () => {
      unsubscribeCommand(rId);
    };
  }, [gameIds, currentSport?.alias]);

  return <GamesFilteredByLeagues sportsData={sportsData} />;
};
